import { ACCOUNT_TYPES } from "@tastyworks/shared-utils/misc/constants"
import {
  ACCOUNT_TYPE_CHOICES,
  ENTITY_ACCOUNT_TYPE_CHOICES,
  IRA_BENEFICIARY_OR_INHERITED_ACCOUNT_TYPE_CHOICES,
  IRA_INDIVIDUAL_ACCOUNT_TYPE_CHOICES,
  JOINT_ACCOUNT_CHOICES,
  RETIREMENT_ACCOUNT_CHOICES,
  TAX_ELECTION_CHOICES,
} from "@tastyworks/tastyworks-api"
import { bool, mixed, object, string } from "yup"

export const accountTypeSelectSchema = object({
  hasNonEntityAccount: bool().default(false).notRequired(),
  accountTypeName: mixed<ACCOUNT_TYPES>().oneOf(Object.values(ACCOUNT_TYPES)),
  accountType: mixed<ACCOUNT_TYPE_CHOICES>()
    .oneOf(Object.values(ACCOUNT_TYPE_CHOICES))
    .required()
    .test(
      "is-entity-account",
      "yup.isEntityPermitted.errorMessage",
      (value, context) => {
        if (value !== ACCOUNT_TYPE_CHOICES.ENTITY) {
          return true
        }
        return !context.parent.hasNonEntityAccount
      }
    ),
})

export const jointAccountTypeSchema = object({
  jointAccountType: mixed<JOINT_ACCOUNT_CHOICES>()
    .oneOf(Object.values(JOINT_ACCOUNT_CHOICES))
    .required(),
})

export const retirementAccountTypeSchema = object({
  retirementAccountType: mixed<RETIREMENT_ACCOUNT_CHOICES>()
    .oneOf(Object.values(RETIREMENT_ACCOUNT_CHOICES))
    .required(),
})

export const decedentNameSchema = object({
  decedentName: string().required(),
})

export const iraIndividualAccountSchema = object({
  iraIndividualAccountType: mixed<IRA_INDIVIDUAL_ACCOUNT_TYPE_CHOICES>()
    .oneOf(Object.values(IRA_INDIVIDUAL_ACCOUNT_TYPE_CHOICES))
    .required(),
})

export const iraBeneficiaryOrInheritedAccountSchema = object({
  iraBeneficiaryOrInheritedAccountType:
    mixed<IRA_BENEFICIARY_OR_INHERITED_ACCOUNT_TYPE_CHOICES>()
      .oneOf(Object.values(IRA_BENEFICIARY_OR_INHERITED_ACCOUNT_TYPE_CHOICES))
      .required(),
})

export const entityAccountTypeSchema = object({
  entityAccountType: string()
    .oneOf(Object.values(ENTITY_ACCOUNT_TYPE_CHOICES))
    .required(),
})

export const taxElectionSchema = object({
  entityTaxElection: string().oneOf(TAX_ELECTION_CHOICES).required(),
})

export const accountTypeSchema = object({
  accountTypeSelect: accountTypeSelectSchema,
  jointAccountType: jointAccountTypeSchema,
  retirementAccountType: object({
    retirementAccountSelect: retirementAccountTypeSchema,
    iraIndividualAccountType: iraIndividualAccountSchema,
    iraBeneficiaryOrInheritedAccountType:
      iraBeneficiaryOrInheritedAccountSchema,
    decedentName: decedentNameSchema,
  }),
  entityAccountType: object({
    entityType: entityAccountTypeSchema,
    taxElection: taxElectionSchema,
  }),
})
